export function MealBadge({ meal }: { meal: 'breakfast' | 'lunch' | 'dinner' }) {
  return (
    <span className="inline-flex items-center rounded-full border border-line bg-card px-2.5 py-0.5 font-sans text-[0.7rem] font-medium uppercase tracking-[0.08em] text-ink-soft">
      {meal}
    </span>
  );
}
